/**
 * Reusable marketing/public header. Sticky, glass-blurred, branded.
 *
 * Used on every public-facing or auth page (Landing, Login, Register, Audit,
 * AuditSuccess, BillingSuccess, Paywall). NOT used inside the authenticated
 * dashboard, which has its own AppLayout sidebar.
 *
 * Variants are controlled by props:
 *   - showSubscribe (default true)  - hides the white "Subscribe" CTA on pages
 *     where it would be redundant (e.g. the Paywall itself).
 *   - showSignIn (default true)
 *   - showAudit (default true)
 *   - rightSlot - optional ReactNode rendered on the far right (e.g. Sign out
 *     button on Paywall).
 */
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

export default function MarketingHeader({
  showSubscribe = true,
  showSignIn = true,
  showAudit = true,
  rightSlot = null,
}) {
  const navigate = useNavigate();
  return (
    <header
      className="sticky top-0 z-30 border-b border-[#161616] backdrop-blur-xl bg-[rgba(10,10,10,0.85)]"
      data-testid="marketing-header"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center" data-testid="marketing-header-logo-link">
          <Logo variant="white" className="h-7" />
        </a>
        <div className="flex items-center gap-4">
          {showAudit && (
            <a
              href="/free-audit"
              className="text-xs font-mono uppercase tracking-[0.2em] text-neutral-400 hover:text-white"
              data-testid="nav-audit"
            >
              Free AI audit
            </a>
          )}
          {showSignIn && (
            <a
              href="/login"
              className="text-xs font-mono uppercase tracking-[0.2em] text-neutral-400 hover:text-white"
              data-testid="nav-login"
            >
              Sign in
            </a>
          )}
          {showSubscribe && (
            <button
              onClick={() => navigate("/register")}
              className="text-xs font-mono uppercase tracking-[0.2em] bg-white text-black px-3 py-2 rounded-md hover:bg-neutral-200"
              data-testid="nav-subscribe"
            >
              Subscribe
            </button>
          )}
          {rightSlot}
        </div>
      </div>
    </header>
  );
}
